import ChartSection from "../../../chart/ChartSection";
import Header from "./Header";
import Chart from "./chart/Chart";
import {SORT_ORDER, comparator} from "../../../atUtils";
import SortButton from "../../../controls/SortButton";
import messageResource from "../../../messageResource";
import SortButtons, {SORT_BY} from "./SortButtons";
import {SHOW_IN} from "./TableChartButtons";
import TableChartButtons from "./TableChartButtons";
import ReportedTimeSummaryRecords from './ReportedTimeSummaryRecords'
import {OTHER_USERS_ENTITY_ID} from "../../../constants"


export default class Totals extends ChartSection {

    constructor($containerEl, {
        chartContainerId,
        triggerScrollUpdate = () => {}
    }) {
        super($containerEl, {chartContainerId, needPdf: false});

        this.params= {
            ...this.params,
            triggerScrollUpdate
        }

        this.state = {
            ...this.state,
            totalTime: null,
            myRecord: null,
            myTeamRecords: [],
            othersRecords: [],
            myTeamTotal: 0,
            othersTotal: 0,
            sorted: false,
            sorting: {
                by: null,
                order: null,
            },
            showIn: SHOW_IN.TABLE,
        }

        this.onStatePropertyChanged("totalTime", (totalTime) => {
            this.$el.toggle(totalTime !== null);
            this.header.setState({totalTime});
            this.$el.toggleClass("emptySummary", this.state.totalTime === 0)
        });

        this.onAnyStatePropertyChanged(['myTeamRecords', 'othersRecords'], () => {
            if (!this.state.sorted) {
                this.sortSummaryRecords();
            }
        });

        this.onStatePropertyChanged("sorting", (sorting) => {
            this.alphabetB.setState({
                active: sorting.by === SORT_BY.USER,
                order: sorting.order
            });
            this.valueB.setState({
                active: sorting.by === SORT_BY.TIME,
                order: sorting.order
            });
            this.saveSettingsInLocalStorage();
        });

        this.onStatePropertyChanged("sorted", (sorted) => {
            if (sorted) {
                this.setState({rendering: true});
                this.table.setState({
                    myRecord: this.state.myRecord,
                    myTeamRecords: this.state.myTeamRecords,
                    othersRecords: this.state.othersRecords,
                    myTeamTotal: this.state.myTeamTotal,
                    othersTotal: this.state.othersTotal,
                })
                this.chart.setState({summaryRecords: this._getRecordsForChart()})
            }
        })

        this.onStatePropertyChanged("showIn", () => {
            this._updateTotalsShowIn()
        })
    }

    _updateTotalsShowIn() {
        this.tableChartControl.setState({
            showIn: this.state.showIn
        })
        this.$el.toggleClass("showChart", this.state.showIn === SHOW_IN.CHART)
        this.$el.toggleClass("showTable", this.state.showIn === SHOW_IN.TABLE)
        this.params.triggerScrollUpdate()
        this.saveSettingsInLocalStorage()
    }

    afterRender() {
        super.afterRender();
        this.header = new Header(this.$header).init();

        this.chart = new Chart(this.$chartContainer, {
            onRendered: () => {
                this.setState({rendering: false});
                this.params.triggerScrollUpdate();
            }
        }).init();
        this.table = new ReportedTimeSummaryRecords().init(this.$el)

        this.alphabetB = new SortButton(null, {
            titleLabel: messageResource.getMessage("report.create_chart.sort.alphabetically"),
            onClick: (order) => {
                this.setState({
                    sorting: {
                        by: SORT_BY.USER,
                        order: order,
                    },
                    sorted: false
                })
                this.sortSummaryRecords();
            }
        });

        this.valueB = new SortButton(null, {
            titleLabel: messageResource.getMessage("report.create_chart.sort.value"),
            onClick: (order) => {
                this.setState({
                    sorting: {
                        by: SORT_BY.TIME,
                        order: order,
                    },
                    sorted: false
                });
                this.sortSummaryRecords();
            }
        });
        this.sortButtons = new SortButtons(this.$header, [this.alphabetB, this.valueB]).init();

        this.tableChartControl = new TableChartButtons(this.$header, {
            onClick: (showIn) => {
                this.setState({showIn})
            }
        }).init();

        this.rendered = true // ugly hack for ugly code
        if (!window.localStorage.taskPanelReportedTimeSettings) {
            this.setState({
                sorting: {by: SORT_BY.USER, order: SORT_ORDER.DESC},
                showIn: SHOW_IN.TABLE,
                collapsed: false
            });
            this.saveSettingsInLocalStorage();
        } else {
            this.setState(JSON.parse(window.localStorage.taskPanelReportedTimeSettings))
        }
        this._updateTotalsShowIn()
    }

    sortSummaryRecords() {
        let myTeamRecordsSorted = this.state.myTeamRecords ?
                                this.state.myTeamRecords.slice().sort(comparator(this.state.sorting.by, this.state.sorting.order)) :
                                this.state.myTeamRecords
        let othersRecordsCopy = this.state.othersRecords.slice()
        othersRecordsCopy.sort(comparator(this.state.sorting.by, this.state.sorting.order))
        this.setState({
            sorted: true,
            myTeamRecords: myTeamRecordsSorted,
            othersRecords: othersRecordsCopy,
        })
    }

    setScrollUpdateCallback(updateScroll = () => {}) {
        this.params.triggerScrollUpdate = updateScroll;
    }

    onCollapsed(collapsed) {
        super.onCollapsed(collapsed);
        this.saveSettingsInLocalStorage();
    }

    saveSettingsInLocalStorage() {
        window.localStorage.taskPanelReportedTimeSettings = JSON.stringify({
            sorting: this.state.sorting,
            showIn: this.state.showIn,
            collapsed: this.state.collapsed
        });
    }

    _getRecordsForChart() {
        let summaryRecords = []
        summaryRecords = summaryRecords.concat(this.state.myTeamRecords || [])
        summaryRecords = summaryRecords.concat(this.state.myRecord || [])
        summaryRecords = summaryRecords.concat(
            this.state.othersRecords.length !== 0
                ? this.state.othersRecords
                : {
                    "spentTime": this.state.othersTotal,
                    "userId": OTHER_USERS_ENTITY_ID,
                    "commentsAvailable": false,
                    "firstName": "",
                    "lastName": "",
                    "formattedName": "",
                    "middleName": "",
                    "username": ""
                }
        )
        return summaryRecords
    }
}



// WEBPACK FOOTER //
// ./web/js/panels/task/reportedTime/Totals.js